import Vue from 'vue';
import VueRouter from 'vue-router';
import VeeValidate from 'vee-validate';
import {sessionSaveState} from '@khamer/vue-save-state';
import store from './store';

import OrderForm from './components/order/Form';
import OrderReview from './components/order/Review';
import OrderConfirmation from './components/order/Confirmation';

import ComponentHelpers from './ComponentHelpers';

Vue.use(VueRouter);
Vue.mixin(ComponentHelpers);

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/order',
            component: OrderForm,
            name: 'form',
            meta: {
                title: 'Enter Your ZIP Code - OrderMyOil.com',
            },
        },
        {
            path: '/order/:zip([0-9]{5}):sep(-)?:slug?',
            component: OrderForm,
            name: 'form-with-zip',
            meta: {
                title: ({zip}) => `Buy Heating Oil in ${zip} - OrderMyOil.com`,
            },
        },
        {
            path: '/order/review',
            component: OrderReview,
            name: 'review',
            meta: {
                title: "Review your Order - OrderMyOil.com",
            },
        },
        {
            path: '/order/confirmation',
            component: OrderConfirmation,
            name: 'confirmation',
            meta: {
                title: "Order Confirmation - OrderMyOil.com",
            },
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0};
    },
});

router.beforeEach((to, from, next) => {
    let title = null;
    if (typeof(to.meta.title) == 'function') {
        title = to.meta.title(to.params);
    } else {
        title = to.meta.title;
    }
    if (title) {
        document.title = title;
    }
    next();
});

const app = new Vue({
    mixins: [sessionSaveState],

    store,
    router,

    data() {
        return {
            allow_skipping_payment: false,
            zipCode: null,

            order: {
                address_id: null,
                agree_to_terms: false,
                company_id: null,
                cross_street: "",
                delivery_method: 'Standard',
                fill_tank: false,
                gallons: null,
                gauge_reading: "",
                invoice_number: '',
                location: null,
                needs_prime: false,
                ownership: 'Own',
                property_type: 'Residential',
                special_instructions: null,
                street: "",
                tank_size: null,
                tank_size_unknown: false,
                tax_rate: null,
                transaction_id: '',
                zip_code: null,
            },

            estimate: {},
            flashMessages: {},
            detailOrder: {},
            deliveryFeeWarning: '',

            user: window.user
        };
    },

    watch: {
        "order.fill_tank"(value) {
            if (value === true) {
                this.order.gallons = null;
            }
            this.fetchEstimate();
        },
        "order.tank_size_unknown"(value) {
            if (value === true) {
                this.order.tank_size = null;
            }
            this.fetchEstimate();
        },
        "order.gallons"() {
            this.fetchEstimate();
        },
        "order.fill_tank"() {
            this.fetchEstimate();
        },
        "order.delivery_method"() {
            this.fetchEstimate();
        },
        "order.needs_prime"() {
            this.fetchEstimate();
        },
        "order.property_type"() {
            this.fetchEstimate();
        },
        "order.tank_size"() {
            this.fetchEstimate();
        },
        "order.tank_size_unknown"() {
            this.fetchEstimate();
        },
        "order.needs_prime"() {
            this.fetchEstimate();
        },
    },

    methods: {
        fetchEstimate: (_.debounce(function() {
            if (!this.zipCode) {
                this.estimate = {};
                return;
            }

            Object.assign(
                { zip_code: this.zipCode.zip_code },
                this.order
            );

            axios.get('/order/api/estimate', {
                params: { ...this.order },
            }).then(response => {
                this.estimate       = response.data.data;
                this.order.tax_rate = this.estimate.tax_rate;

                if (this.estimate.delivery_fee) {
                    this.setDeliveryFeeWarning(this.estimate.gallons);
                } else {
                    this.deliveryFeeWarning = '';
                }
            }).catch(response => {
                this.estimate = {};
            });
        }, 400)),

        getSaveStateConfig() {
            return {
                'cacheKey': 'order',
                'saveProperties': ['order']
            };
        },
        setFlashMessage(type, message)
        {
            this.flashMessages[type] = message;
        },
        getFlashMessage(type, clean=false)
        {
            if (this.flashMessages[type] != 'undefined') {
                var message = this.flashMessages[type];

                if (clean) {
                    this.setFlashMessage(type, '');
                }

                return message;
            }
            return '';
        },

        setDeliveryFeeWarning(gallons)
        {
            if (gallons < 100 && this.zipCode.zone.small_order_fee > 0) {
                this.deliveryFeeWarning = 'Orders less than 100 gallons will be charged a small order fee of $' + this.zipCode.zone.small_order_fee;
                return;
            }
            if (gallons < 150 && this.zipCode.zone.medium_order_fee > 0) {
                this.deliveryFeeWarning = 'Orders less than 150 gallons will be charged a small order fee of $' + this.zipCode.zone.medium_order_fee;
                return;
            }

            this.deliveryFeeWarning = '';
        },
    },

    mounted() {

        this.allow_skipping_payment = !!this.$el.getAttribute('allow_skipping_payment');

        if (window.matchMedia("(min-width: 1199px)").matches) {
            $('body').on('mouseenter mouseleave','.dropdown-menu',function(e){
                var _d = $(e.target).closest('.dropdown-menu');
                setTimeout(function(){
                    _d[_d.is(':hover')?'addClass':'removeClass']('show');
                },300);
            });
        }
    },

}).$mount('main');
